// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const BackTop: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10.5" viewBox="0 0 9 10.5">
            <path
                fill="#AED639"
                d="M8.25,9.00025213 L0.728906393,9.00025213 C0.335859418,9.00025213 0,9.33540809 0,9.72915852 C0,10.1229089 0.335859418,10.5002521 0.728906393,10.5002521 L8.25,10.5002521 C8.66484404,10.5002521 9,10.1650962 9,9.75025213 C9,9.33540809 8.66484404,9.00025213 8.25,9.00025213 Z M1.3125,4.4955647 L3,4.4955647 L3,7.49790895 C3,7.91251838 3.33585942,8.24884665 3.75,8.24884665 L5.25,8.24884665 C5.66414058,8.24884665 6,7.91251838 6,7.49790895 L6,4.4955647 L7.6875,4.4955647 C7.91198444,4.4955647 8.11523438,4.36178362 8.20429659,4.1554867 C8.29291391,3.94916654 8.25079679,3.70947111 8.09662485,3.5461117 L4.90912485,0.16876781 C4.69673431,-0.0562559366 4.30349994,-0.0562559366 4.09092164,0.16876781 L0.90342164,3.5461117 C0.749249697,3.70956481 0.707132578,3.94923663 0.795749903,4.1554867 C0.884765983,4.36197102 1.08796906,4.4955647 1.31250036,4.4955647 L1.3125,4.4955647 Z"
            />
        </svg>
    );
};

export default React.memo(BackTop);
